import { Form } from 'antd';
import { DateTime } from 'luxon';
import type { FC } from 'react';
import { DatePicker } from '../../BasicComponents/DateTimePicker';

export const CloseAfterDatePicker: FC = () => {
  const minDate = Form.useWatch('plannedAt') || DateTime.now();

  return (
    <Form.Item
      label="Not after"
      name="closeAfter"
      dependencies={['plannedAt']}
      tooltip="If the message hasn't been sent by the deadline, it will be categorized as either 'not acknowledged' or 'not sent,' depending on the number of attempts made."
      rules={[
        {
          validator: (_, value) => (value < minDate ? Promise.reject() : Promise.resolve()),
          message: 'Has to be greater then "Not before"',
        },
      ]}
    >
      <DatePicker
        minDate={minDate}
        showTime
        allowClear={false}
        presets={[
          { label: '1 hour', value: DateTime.now().plus({ hours: 1 }) },
          { label: '1 day', value: DateTime.now().plus({ days: 1 }) },
          { label: '1 week', value: DateTime.now().plus({ days: 7 }) },
        ]}
      />
    </Form.Item>
  );
};
